import { Outlet, useOutletContext } from "react-router-dom";

export default function ForwardContext() {
	return <Outlet context={useOutletContext()} />;
}
